<template>
    <div>
        <modal class="mobile-redirect"  :display="modalStatus.mobileRedirect" @modalStatus="closeModal" >
            <h1>登入飛豬找房 APP</h1>
            <div class="mobile-redirect-wrap">
                <div class="content">
                    為了提供您更好的體驗，請使用飛豬管家APP登入
                </div>
            </div>
            <div class="btn-group">
                <button class="default-button confirm" @click="mobileRedirect()">確定</button>
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import { mapGetters } from 'vuex'
import constant from '@/constant'

export default {
    data () {
        return {

        }
    },
    methods: {
        mobileRedirect: function () {
            let _self =this
            _self.$analytics.logEvent('手機登入引導', { screen_name: '手機登入引導'})
            document.location = constant.fetuzbookTenantSchema+'://';
            var time = (new Date()).getTime();
            setTimeout(function(){
                setTimeout(function(){ // <-- start new thread after activation
                    var now = (new Date()).getTime();
                    if((now - time)<400) {
                        if(confirm('你未安裝飛豬找房，將引導AppStore')){
                            window.open(_self.appUrl.landlord)
                        }
                    }
                }, 10); // <-- start new thread after activation
            }, 300);
        },
        closeModal: function () {
            this.$store.dispatch('setModalStatus', {state: false, type: 'mobileRedirect'})
        },
    },
    computed: {
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
            system: 'GET_DEVICE_SYSTEM',
            appUrl: 'GET_APP_URL',
        })
    },
    components: {
        Modal,
    }
}
</script>
<style lang="scss"  >
    #modal.mobile-redirect{
        .error{
            right: 0px;
            top: -24px;
            left: unset;
        }
        .modal-content{
            width: 368px;
            height: 300px;
            padding: 0 !important;
            .detail{
                >h1{
                    margin-top: 32px;
                    margin-bottom: 24px;
                    font-size: 24px;
                }
                .mobile-redirect-wrap{
                    padding: 0 58px;
                    padding-bottom: 90px;
                    .content{
                        text-align: center;
                        line-height: 1.5;
                    }
                }
            }
            
            .btn-group{
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 84px;
                box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                border-radius:  0 0 20px 20px;
                margin: 0 auto;
                button{
                    width: 308px;
                    height: 44px;
                }
            }
        }
    }
    @media screen and (max-width: 375px) {
         #modal.mobile-redirect{
            .modal-content{
                width: 280px;
                height: 250px;
                .cancle{
                    top: 8px !important; 
                    right: 8px !important;
                }
                .detail{
                    .mobile-redirect-wrap{
                        padding-bottom: 41px;
                    }
                }
                .btn-group{
                    button{
                        width: 208px;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/widge/modal/mobileRedirect.vue